import React from 'react';
import { Box } from '@common-fe/common-fe';

import { CreateMainContact } from '@/modules/ExpressSetup/ExpressSetupSignUp/CreateMainContact';

const ExpressSetupCreateMainContactPage = () => {
  return (
    <Box style={{ minHeight: '100vh' }} width="100%">
      <CreateMainContact />
    </Box>
  );
};

export default ExpressSetupCreateMainContactPage;
